/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindEnrollmentScheduleResponseDto } from '../../models/find-enrollment-schedule-response-dto';

export interface EnrollmentScheduleControllerFindAllByTicketIdV1$Params {
  ticketId: string;

/**
 * 타입
 */
  type?: 'TREATMENT' | 'COUNSELING' | 'SUPPLEMENT' | 'ALL';

/**
 * 문서 작성 상태
 */
  logStatus?: 'PENDING' | 'COMPLETED';

/**
 * 시작일
 */
  startAt?: string;

/**
 * 종료일
 */
  endAt?: string;

/**
 * 센터 ID
 */
  centerId?: string;

/**
 * 아동 ID
 */
  childId?: string;

/**
 * 취소 여부
 */
  isCancelled?: boolean;

/**
 * 연도
 */
  year?: string;

/**
 * 상태
 */
  statusList?: Array<'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELED'>;
}

export function enrollmentScheduleControllerFindAllByTicketIdV1(http: HttpClient, rootUrl: string, params: EnrollmentScheduleControllerFindAllByTicketIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<FindEnrollmentScheduleResponseDto>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleControllerFindAllByTicketIdV1.PATH, 'get');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('type', params.type, {});
    rb.query('logStatus', params.logStatus, {});
    rb.query('startAt', params.startAt, {});
    rb.query('endAt', params.endAt, {});
    rb.query('centerId', params.centerId, {});
    rb.query('childId', params.childId, {});
    rb.query('isCancelled', params.isCancelled, {});
    rb.query('year', params.year, {});
    rb.query('statusList', params.statusList, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindEnrollmentScheduleResponseDto>;
    })
  );
}

enrollmentScheduleControllerFindAllByTicketIdV1.PATH = '/api/v1/enrollment-schedule/ticket/all/{ticketId}';
